import React, { Component } from "react";
import {
  NavBar,
  Icon,
  List,
  Button,
  Checkbox,
  ActionSheet,
  Toast,
  WhiteSpace,
  Pagination,
  WingBlank,
  SearchBar,
  Popover,
} from "antd-mobile";
import "./groupList.scss";
import axios from "../../../service/axios";
import GroupSearch from "../../../components/search/search";
import NoneDatas from "../../../components/noneDatas";
import ImMeassage from "../../../components/imMessage/imMessage";
import BatchModifyGroup from "./batchModifyGroup";
const CheckboxItem = Checkbox.CheckboxItem;
const Item = List.Item;
const more_icon = require("../../../assets/images/icon/more_icon.png");
const im_icon = require("../../../assets/images/icon/im_icon.svg");
const modify_icon = require("../../../assets/images/icon/modify_icon.svg");
const drawerContainer = {
  position: "fixed",
  width: "100%",
  top: "45px",
  background: "#f5f5f5",
  height: "100%",
  zIndex: "11",
  transition: "left 0.4s",
};
export class GroupList extends Component {
  state = {
    showCheck: false,
    groupDatas: [],
    selectNum: 0,
    selectGids: [],
    pageTotalNum: 0,
    pageNo: 1,
    drawerSearch: document.body.clientWidth,
    drawerImMessage: document.body.clientWidth,
    drawerLeftModifyGroup: document.body.clientWidth,
    searchKey: {},
    visible: false,
    imKey: 100,
  };
  onChange = (e, i) => {
    if (e.target.checked) {
      this.setState({
        selectNum: this.state.selectNum + 1,
        selectGids: [...this.state.selectGids, i.gid],
      });
    } else {
      let selectGids = this.state.selectGids;
      selectGids.splice(selectGids.indexOf(i.gid), 1);
      this.setState({
        selectGids: selectGids,
        selectNum: this.state.selectNum - 1,
      });
    }
  };
  componentWillMount() {
    this.getGroupList();
    sessionStorage.removeItem("groupRemarks");
  }
  deleteBtn() {
    if (this.state.selectNum < 1) {
      Toast.info("请选择要删除的群组", 1);
      return;
    }
    const BUTTONS = ["确定", "取消"];
    ActionSheet.showActionSheetWithOptions(
      {
        options: BUTTONS,
        message: "是否删除选中的群组？",
        maskClosable: true,
        "data-seed": "logId",
      },
      async buttonIndex => {
        if (!buttonIndex) {
          this.deleteGroups();
        }
      },
    );
  }
  deleteGroups() {
    axios
      .post("/api/group/delete", {
        gids: this.state.selectGids,
      })
      .then(res => {
        if (res && res.status == 200) {
          Toast.success("操作成功");
          this.getGroupList(1);
          this.setState({
            showCheck: false,
          });
        } else {
          Toast.fail("删除失败");
        }
      });
  }
  getGroupList(e) {
    axios
      .post("/api/group/list", {
        page: {
          pageNo: e,
          pageSize: 10,
        },
        pttGroupEntity: {
          ...this.state.searchKey,
        },
      })
      .then(res => {
        if (res && res.status == 200 && res.data) {
          if (res.data.resultList) {
            this.setState({
              groupDatas: res.data.resultList.map(item => {
                item.checked = false;
                return item;
              }),
              pageNo: res.data.pageNo,
              pageTotalNum: Math.ceil(res.data.totalCount / 10),
            });
          } else {
            this.setState({
              groupDatas: [],
              pageNo: res.data.pageNo,
              pageTotalNum: Math.ceil(res.data.totalCount / 10),
            });
          }
        }
      });
  }
  onPageChange(e) {
    const { pageTotalNum } = this.state;
    e = e > pageTotalNum ? pageTotalNum : e;
    this.getGroupList(e);
    this.setState({
      selectNum: 0,
      selectGids: [],
    });
  }
  onSearchList = e => {
    console.log(e);
    this.setState({
      searchKey: {
        ...e,
      },
      drawerSearch: document.body.clientWidth,
    });
    setTimeout(() => {
      this.getGroupList(1);
    }, 0);
  };
  sendGroupMessage(messages) {
    axios.post("/api/mqtt/server/group/send", {
      gids: this.state.selectGids,
      messages,
    }).then(res => {
      if (res.status == 200) {
        Toast.info("发送成功", 1);
      } else {
        Toast.fail(res.message);
      }
    });
  };
  openImMessage() {
    if (this.state.selectNum < 1) {
      Toast.info("请选择群组", 1);
      return;
    }
    this.setState({
      imKey: this.state.imKey == 100 ? 111 : 100,
      drawerImMessage: 0,
    })
  };
  modifyGroupInfo() {
    if (this.state.selectNum < 1) {
      Toast.info("请选择群组", 1);
      return;
    }
    this.setState({
      drawerLeftModifyGroup: 0,
    })
  };
  onSelect = (opt) => {
    const selected = opt.props.value;
    if ('message' == selected) {
      this.openImMessage();
    } else {
      this.modifyGroupInfo();
    }
    this.setState({
      visible: false,
    });
  };
  handleVisibleChange = (visible) => {
    this.setState({
      visible,
    });
  };

  render() {
    const { drawerSearch, drawerImMessage, drawerLeftModifyGroup } = this.state;
    const data = [];
    for (let i = 0; i < 100; i++) {
      data.push({
        value: i,
        label: "zhaoyu" + i,
      });
    }

    const userMsg =
      sessionStorage.getItem("loginMsg") &&
      JSON.parse(sessionStorage.getItem("loginMsg"));
    const { groupDatas, selectNum, pageTotalNum, pageNo } = this.state;
    return (
      <div className="groupList">
        <div className="header-sticky">
          <NavBar
            icon={<Icon type="left" />}
            onLeftClick={() => this.props.history.push("/menu")}
            rightContent={[
              userMsg.userType >= 1 && userMsg.userType <= 3 ? (
                ""
              ) : this.state.showCheck ? (
                <Icon
                  onClick={() => {
                    this.setState({
                      showCheck: false,
                    });
                  }}
                  key="1"
                  type="check"
                />
              ) : (
                    <div key="3">
                      <Icon
                        size="sm"
                        type="search"
                        onClick={() =>
                          this.setState({
                            drawerSearch: 0,
                          })
                        }
                      />
                      &ensp; &ensp;
                      <img
                        onClick={() => {
                          this.setState({
                            showCheck: true,
                            selectNum: 0,
                          });
                        }}
                        key="0"
                        src={more_icon}
                      />
                    </div>
                  ),
            ]}
          >
            群组列表
          </NavBar>
        </div>

        <div className="sub-container">
          <List>
            {groupDatas.map((i, index) => {
              return (
                <div key={index}>
                  {this.state.showCheck ? (
                    <CheckboxItem
                      key={index}
                      onChange={e => this.onChange(e, i)}
                    >
                      {i.name}
                    </CheckboxItem>
                  ) : (
                      <Item
                        key={index}
                        arrow="horizontal"
                        onClick={() => {
                          this.props.history.push(
                            `/addgroup/edit/${i.gid}/${i.name}`,
                          );
                          sessionStorage.setItem("groupRemarks", i.remarks);
                        }}
                      >
                        {i.name}
                      </Item>
                    )}
                </div>
              );
            })}
          </List>
          {groupDatas.length == 0 ? <NoneDatas /> : ""}
          <WhiteSpace />
          <WingBlank>
            <SearchBar
              placeholder="请输入跳转页面"
              onSubmit={value => this.onPageChange(value)}
            />
          </WingBlank>
          <WhiteSpace />
          <WingBlank>
            {pageTotalNum > 0 ? (
              <Pagination
                total={pageTotalNum}
                current={pageNo}
                locale={{
                  prevText: "上一页",
                  nextText: "下一页",
                }}
                onChange={e => this.onPageChange(e)}
              />
            ) : (
                ""
              )}
          </WingBlank>

          {this.state.showCheck ? (
            <div className="footer">
              <span>
                已选择：
                {selectNum}
                个群组
              </span>
              <Button
                type="warning"
                inline
                size="small"
                onClick={() => this.deleteBtn()}
              >
                删除
              </Button>
              <Popover
                overlayClassName="fortest"
                overlayStyle={{ color: 'currentColor' }}
                visible={this.state.visible}
                placement="topRight"
                overlay={[
                  // (<Popover.Item key="1" value="message" icon={<img src={im_icon} className="am-icon am-icon-xs" alt="" />}>
                  //   发送通知
                  // </Popover.Item>),
                  (<Popover.Item key="3" value="info" icon={<img src={modify_icon} className="am-icon am-icon-xs" alt="" />}>
                    批量修改信息
                  </Popover.Item>),
                ]}
                align={{
                  overflow: { adjustY: 0, adjustX: 0 },
                  offset: [-10, 0],
                }}
                onVisibleChange={this.handleVisibleChange}
                onSelect={this.onSelect}
              >
                <div style={{
                  height: '100%',
                  padding: '0 15px',
                  marginRight: '-15px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                >
                  <Icon type="ellipsis" />
                </div>
              </Popover>
            </div>
          ) : (
              ""
            )}
          <div className="" style={{ ...drawerContainer, left: drawerSearch }}>
            <GroupSearch
              closeSearch={() =>
                this.setState({
                  drawerSearch: document.body.clientWidth,
                })
              }
              onSearchList={this.onSearchList}
              type="group"
            />
          </div>
          <div className="im" style={{ ...drawerContainer, left: drawerImMessage }}>
            <ImMeassage
              key={this.state.imKey}
              ids={this.state.selectGids}
              sendMessage={e => this.sendGroupMessage(e)}
              closeIm={() =>
                this.setState({
                  drawerImMessage: document.body.clientWidth,
                })}
              type="group"
            />
          </div>
          <div className="batch-modify" style={{ ...drawerContainer, left: drawerLeftModifyGroup }}>
            <BatchModifyGroup
              groupList={groupDatas ? groupDatas.filter(item => this.state.selectGids.includes(item.gid)) : []}
              handleChildClose={() =>
                this.setState({
                  drawerLeftModifyGroup: document.body.clientWidth,
                })}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default GroupList;
